import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  connect() {
    this.dragging = false;
    this.startX = 0;
    this.scrollLeft = 0;
    this.scrollSpeed = 1; // Adjust speed here
    this.animationFrame = null;
    this.isAnimating = false; // Track animation state

    // Duplicate content for infinite scrolling
    this.element.innerHTML += this.element.innerHTML;

    this.startAnimation();
  }

  disconnect() {
    this.stopAnimation();
  }

  startAnimation() {
    if (this.isAnimating) return; // Prevent multiple animation loops
    this.isAnimating = true;

    const move = () => {
      this.element.scrollLeft += this.scrollSpeed;

      // Reset scroll position when reaching the duplicated content
      if (this.element.scrollLeft >= this.element.scrollWidth / 2) {
        this.element.scrollLeft = 0;
      }

      this.animationFrame = requestAnimationFrame(move);
    };
    this.animationFrame = requestAnimationFrame(move);
  }

  stopAnimation() {
    cancelAnimationFrame(this.animationFrame);
    this.isAnimating = false; // Mark animation as stopped
  }

  pauseAnimation() {
    this.stopAnimation();
  }

  resumeAnimation() {
    this.startAnimation();
  }

  startDragging(event) {
    this.dragging = true;
    this.startX = event.pageX - this.element.offsetLeft;
    this.scrollLeft = this.element.scrollLeft;
    this.stopAnimation();
  }

  stopDragging() {
    this.dragging = false;
    this.startAnimation();
  }

  drag(event) {
    if (!this.dragging) return;

    const x = event.pageX - this.element.offsetLeft;
    const walk = (x - this.startX) * 2; // Adjust drag sensitivity
    this.element.scrollLeft = this.scrollLeft - walk;
  }
}

